import * as React from "react";

import { UserDataType } from "../types/interfaces";

interface ProviderProps {
  children?: any;
}

export interface ContextValueType {
  userData: UserDataType | null;
  setUserData: React.Dispatch<React.SetStateAction<UserDataType | null>>;
}

const ContextDefaultValue: ContextValueType = {
  userData: null,
  setUserData: (state) => {},
};

export const Context = React.createContext(ContextDefaultValue);

export const ContextProvider = (props: ProviderProps) => {
  const [userData, setUserData] = React.useState<UserDataType | null>(null);

  return (
    <Context.Provider value={{ userData, setUserData }}>
      {props.children}
    </Context.Provider>
  );
};
